import React from 'react';
import cn from 'classnames';
import styles from './PerformerItem.module.scss';

const getTrimmedText = (value) =>
  typeof value === 'string' ? value.trim() : '';

const getPerformerSpeciality = (performer = {}) =>
  getTrimmedText(performer.specialityName) ||
  getTrimmedText(performer.speciality) ||
  (performer.specializations || [])
    .map(getTrimmedText)
    .filter(Boolean)
    .join(', ');

export const PerformerItem = ({
  performer,
  className,
  component: Component = 'li',
  fluid = false,
  compact = false,
  isActive = false,
  isInteractive = false,
  onClick,
}) => {
  const speciality = getPerformerSpeciality(performer);
  const phoneNumber = getTrimmedText(performer.phoneNumber);

  return (
    <Component
      className={cn(styles.root, className, {
        [styles.fluid]: fluid,
        [styles.compact]: compact,
        [styles.active]: isActive,
        [styles.interactive]: isInteractive,
      })}
      onClick={onClick}
    >
      <div className={styles.content}>
        <span className={styles.name}>{performer.fullName}</span>
        {(speciality || phoneNumber) && (
          <div className={styles.details}>
            {speciality && (
              <span className={styles.specializations}>{speciality}</span>
            )}
            {phoneNumber && (
              <span className={styles.phoneNumber}>{phoneNumber}</span>
            )}
          </div>
        )}
      </div>
      <div className={styles.actions}>
        <span className={styles.workingHours}>{performer.workingHours} ч.</span>
      </div>
    </Component>
  );
};
